import React from "react";
const NoData = ({ message = "", detail = "", logo, }) => {
    return (React.createElement("div", { className: "empty-state" },
        logo && (React.createElement("div", { className: "empty-circle" },
            React.createElement("img", { src: logo, alt: "empty-state-logo" }))),
        React.createElement("p", { style: {
                whiteSpace: "pre-line",
                fontWeight: "bolder",
                fontSize: "medium",
                margin: 0,
            } }, message),
        React.createElement("p", { style: { fontSize: "small", margin: 0, width: "80%" } }, detail)));
};
export default NoData;
